import { useApplicationContext } from "components/Application";
import { CartVariant } from "components/CartVariant";
import { capitalize } from "lodash";
import numeral from "numeral";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import "twin.macro";

type CartItemProps = {
  document: any;
  rowGroup: any;
  maxSizes: number;
  refetch: any;
  dirtyRows: string[];
  setDirtyRows: React.Dispatch<React.SetStateAction<string[]>>;
  stock: boolean;
};

export const CartItem: React.FC<CartItemProps> = (props) => {
  const { document, rowGroup, maxSizes, refetch, dirtyRows, setDirtyRows, stock } = props;
  const {
    siteEnvironment: { appEndpointStore },
  } = useApplicationContext();

  const referenceItem = rowGroup[0].referenceItem;

  const { i18n } = useTranslation();
  const languageSuffix = capitalize(i18n.language);

  return (
    <div tw="lg:flex lg:justify-between lg:w-auto lg:mb-12 mb-12 lg:px-0 w-screen px-2">
      <div tw="lg:hidden flex flex-row space-x-8">
        <img tw="h-32" src={`${appEndpointStore}${referenceItem.cover}`} alt={referenceItem[`name${languageSuffix}`]} />
        <div>
          <p tw="">
            <strong>{referenceItem[`name${languageSuffix}`]}</strong>
            <br />
            {referenceItem[`shortDescription${languageSuffix}`]}
          </p>
          <p tw="">
            {i18n.language === "it" ? "Prezzo: " : "Price: "} {numeral(rowGroup[0].price).format("$0,0.00")}
          </p>
          <p>
            <Link
              to={`/b/${referenceItem.brand.id}/s/${referenceItem.season.id}/i/${referenceItem.id}`}
              tw="lg:block text-center border-default py-2 px-8 border-gray-900 text-gray-900 outline-none hover:(text-white bg-gray-900)"
            >
              {i18n.language === "it" ? "SCHEDA ARTICOLO" : "GO TO ITEM"}
            </Link>
          </p>
        </div>
      </div>
      <div tw="lg:block hidden w-32">
        <img tw="h-32" src={`${appEndpointStore}${referenceItem.cover}`} alt={referenceItem[`name${languageSuffix}`]} />
      </div>
      <div tw="lg:block hidden w-1/4 pr-8 pr-0">
        <p tw="mb-4">
          <strong>{referenceItem[`name${languageSuffix}`]}</strong>
          <br />
          {referenceItem[`shortDescription${languageSuffix}`]}
        </p>
        <p tw="mb-4">
          {i18n.language === "it" ? "Prezzo: " : "Price: "} {numeral(rowGroup[0].price).format("$0,0.00")}
        </p>
        <p>
          <Link
            to={`/b/${referenceItem.brand.id}/s/${referenceItem.season.id}/i/${referenceItem.id}`}
            tw="lg:block text-center border-default py-2 px-8 border-gray-900 text-gray-900 outline-none hover:(text-white bg-gray-900)"
          >
            {i18n.language === "it" ? "SCHEDA ARTICOLO" : "GO TO ITEM"}
          </Link>
        </p>
      </div>
      <div tw="lg:w-3/4 w-auto">
        {rowGroup.map((row: any, index: number) => (
          <CartVariant
            key={row.id}
            document={document}
            firstOfGroup={index === 0}
            maxSizes={maxSizes}
            row={row}
            price={row.price}
            refetch={refetch}
            dirtyRows={dirtyRows}
            setDirtyRows={setDirtyRows}
            stock={stock}
          />
        ))}
      </div>
    </div>
  );
};
